import { Button, CircularProgress } from "@mui/material";
import { ReactNode, useState } from "react";
import { SxProps, Theme } from "@mui/material/styles";
import { useTheme } from "@mui/material";


interface AppButtonProps {
  children: ReactNode;
  loading?: boolean;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
  color?: "primary" | "secondary" | "success" | "error" | "warning";
  type?: "button" | "submit" | "reset";
  fullWidth?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  confirm?: boolean;
  confirmText?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const PageButton = ({
  children,
  loading = false,
  disabled = false,
  variant = "contained",
  color = "primary",
  type = "button",
  fullWidth = false,
  startIcon,
  endIcon,
  confirm = false,
  confirmText = "Are you sure?",
  onClick,
  sx,
}: AppButtonProps) => {
  const [confirmed, setConfirmed] = useState(false);
  const theme = useTheme();
  const handleClick = () => {
    if (confirm && !confirmed) {
      setConfirmed(true);
      setTimeout(() => setConfirmed(false), 2000);
      return;
    }
    onClick?.();
  };

  return (
    <Button
      variant={variant}
      color={color}
      type={type}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      startIcon={!loading ? startIcon : undefined}
      endIcon={!loading ? endIcon : undefined}
      onClick={handleClick}
      
      sx={{
        textTransform: "none",
        
      
        fontSize: "1rem",
        borderRadius: 2,
        // backgroundColor: theme.palette.primary.main,
        ":hover": { backgroundColor: theme.palette.primary.dark },
        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress size={22} color="inherit" />
      ) : confirm && confirmed ? (
        confirmText
      ) : (
        children
      )}
    </Button>
  );
};

export default PageButton;
